import { initializeApp, getApps, getApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth"; // 1. Eklendi

const firebaseConfig = {
  apiKey: "AIzaSyAqPCpte9WNt8UztacFBpDmv441TCXLjPs",
  authDomain: "vethelper-356b1.firebaseapp.com",
  databaseURL: "https://vethelper-356b1-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "vethelper-356b1",
  storageBucket: "vethelper-356b1.firebasestorage.app",
  messagingSenderId: "374164250966",
  appId: "1:374164250966:web:3d30b87252875b1093b6f7",
  measurementId: "G-QQ8GPX22K2"
};

// Singleton: Uygulama zaten varsa onu kullan (Duplicate App hatasını önler)
const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();

export const db = getFirestore(app);
export const auth = getAuth(app); // 2. BURASI KRİTİK: export eklendi